/**
 * Favorite toggle handler.
 */
import { syncFavoriteRemote } from '../../modules/api-operations';
import { updateFavoriteCellInPlace } from '../../modules/polling';
import { showToast } from '../../modules/ui';
import type { TableHandlerDeps } from './types';

export async function handleFavoriteToggle(
  id: string,
  e: Event,
  deps: TableHandlerDeps
): Promise<void> {
  const { state, render, ensureAccessToken } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();

  if (state.pendingFavoriteIds && state.pendingFavoriteIds.has(id)) {
    return;
  }

  const newFavoriteState = !lot.favorite;
  if (!state.pendingFavoriteIds) {
    state.pendingFavoriteIds = new Set();
  }
  state.pendingFavoriteIds.add(id);
  // Try in-place update first, fall back to full render
  if (!updateFavoriteCellInPlace(id, lot)) {
    render();
  }

  try {
    await syncFavoriteRemote(id, newFavoriteState, false, state, ensureAccessToken, false);
    state.pendingFavoriteIds.delete(id);
    const lotIndex = state.lots.findIndex((x: unknown) => (x as { id: string }).id === id);
    if (lotIndex >= 0) {
      state.lots[lotIndex].favorite = newFavoriteState;
    }
    // Try in-place update first, fall back to full render
    const updatedLot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
    if (!updatedLot || !updateFavoriteCellInPlace(id, updatedLot)) {
      render();
    }
    showToast(newFavoriteState ? 'Added to favorites' : 'Removed from favorites', {
      type: 'success',
    });
  } catch (err: unknown) {
    state.pendingFavoriteIds.delete(id);
    // Try in-place update first, fall back to full render
    if (!updateFavoriteCellInPlace(id, lot)) {
      render();
    }
    showToast('Failed to update favorite: ' + ((err as Error)?.message || String(err)), {
      type: 'error',
    });
  }
}
